import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setupChunkReload } from './platform/chunk-reload';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element');
}

setupChunkReload();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
